import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { ClientLoggingConfig } from '@app/core/interfaces/c5/client-logging-config';
import { ClientLoggingConfigUpdate } from '@app/core/interfaces/c5/client-logging-config-update';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class ClientLoggingConfigRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  list(): Observable<ClientLoggingConfig[]> {
    return this.getUrl$(`/clientLoggingConfig`).pipe(
      mergeMap((url) => this.http.get<ClientLoggingConfig[]>(url)),
      wrapError('client-logging-config-repository:list')
    );
  }

  update(value: ClientLoggingConfigUpdate): Observable<void> {
    return this.getUrl$(`/clientLoggingConfig`).pipe(
      mergeMap((url) => this.http.put<void>(url, value)),
      wrapError('client-logging-config-repository:update')
    );
  }

  private getUrl$(url: string): Observable<string> {
    return this.utils.apiUrl({
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.EndUser + url,
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.EndUser + url,
      [UserLevel.EndUser]: `/user` + url,
    });
  }
}
